<template>
	<BaseModal
		:visible="visible"
		:title="$t('delete_n', { name: $t('message') })"
		size="lg"
		:loading="state.loading"
		:button-name="$t('delete')"
		@close="emit('close')"
	>
		<div class="flex flex-col items-center p-8 text-center">
			<span class="text-neutral-700 mb-6 text-sm">
				{{ data?.message || "~" }}
			</span>
			<Icon name="mdi:delete" class="text-red-500 h-24 w-24" />
		</div>
		<template #footer>
			<div class="border-gray-200 flex items-center justify-end border-t p-4">
				<button
					class="ripple-bg-white text-neutral-700 border-gray-200 me-4 rounded-xl border-2 px-8 py-3 font-bold"
					@click="emit('close')"
				>
					{{ $t("cancel") }}
				</button>
				<button
					class="ripple-bg-red-500 text-white rounded-xl px-8 py-3 font-bold"
					@click="deleteDevTicketMessage"
				>
					{{ $t("delete_n", { name: $t("message") }) }}
				</button>
			</div>
		</template>
	</BaseModal>
</template>

<script setup lang="ts">
import type { DevTicket, DevTicketMessage } from "~/models/dev-ticket"

const devTicketStore = useDevTicketStore()
const { $toastErrors, $toast, $i18n } = useNuxtApp()

const emit = defineEmits<{
	close: []
	done: [DevTicket]
}>()
const props = defineProps<{
	visible?: boolean
	data?: DevTicketMessage | null
}>()

const state = reactive({
	loading: false
})

const deleteDevTicketMessage = async () => {
	state.loading = true
	try {
		const ticket = await devTicketStore.deleteDevTicketMessage({
			message_id: props.data?.id!
		})
		$toast.success({ message: $i18n.t("n_deleted", { name: $i18n.t("message") }) })
		emit("done", ticket)
		emit("close")
	} catch (e) {
		$toastErrors(e)
	}
	state.loading = false
}
</script>
